import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const UiDesign = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "UI design doesn't happen in isolation. We work from established UX foundations — whether that's our own research or existing flows you bring — and build visual systems that scale. That means design tokens, component libraries, responsive layouts, and a systematic approach that your team can maintain and extend after handover.",
    },
    {
      title: 'Delivery',
      description:
        "Production-ready UI designs in Figma: full component library, defined spacing and type scale, colour system with accessibility checks, responsive variants, and annotated specs ready for developer handover. Delivered in a way your team can actually use — not just admire.",
    },
    {
      title: 'Results',
      description:
        "Interfaces that convert, retain, and impress. UI that's been designed systematically reduces development time, cuts down on design debt, and gives your product a visual coherence that users trust — even if they couldn't tell you exactly why.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="UI Design Services | Heretic Studio"
        description="Great design isn't just beautiful—it works. We craft interfaces that are clear, consistent, and purposeful, ensuring every element supports usability and strengthens your product's identity."
      />
      <div className="studio-page service-page service-page--ui-design">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">UI Design</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">Interfaces that look sharp and work hard</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  Form follows function. Craft interfaces that are clear, consistent, and purposeful
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default UiDesign;
